import { trans } from '../../_00_elements/translation';

export default function enableExpandableTextContent({
  expandLink: {
    selector: expandLinkSelector,
    label: expandLinkLabel = trans('global.see_more'),
    labelExpanded: expandedLinkLabel = trans('global.see_less'),
  },
  content: {
    selector: contentSelector,
    expandedClass: contentExpandedClass = 'expanded',
  },
  section: {
    selector: sectionSelector,
    expandedClass: sectionExpandedClass = 'expanded',
  },
}) {
  const expandLink = document.querySelector(expandLinkSelector);
  const content = document.querySelector(contentSelector);
  const section = document.querySelector(sectionSelector);

  if (!content || !expandLink) {
    return;
  }

  if (content.scrollHeight <= content.clientHeight) {
    expandLink.remove();
    content.classList.remove('background-opacity');
    return;
  }

  function toggleExpansion(event) {
    event.stopPropagation();
    const isExpanded = content.classList.contains(contentExpandedClass);

    section.classList.toggle(sectionExpandedClass);

    if (isExpanded) {
      content.classList.remove(contentExpandedClass);
      content.classList.add('background-opacity');

      expandLink.textContent = expandLinkLabel;
    } else {
      content.style.maxHeight = null;

      content.classList.add(contentExpandedClass);
      content.classList.remove('background-opacity');
      expandLink.textContent = expandedLinkLabel;
    }
  }

  expandLink.addEventListener('click', toggleExpansion);

  section.addEventListener('click', (event) => {
    const isExpanded = content.classList.contains(contentExpandedClass);

    if (isExpanded) {
      return;
    }

    toggleExpansion(event);
  });
}

export function initExpandableTextContent({ expandLinkLabel = undefined } = {}) {
  enableExpandableTextContent({
    expandLink: {
      selector: '.page-details__description .page-details__expand-button',
      label: expandLinkLabel,
    },
    content: {
      selector: '.page-details__description-content',
    },
    section: {
      selector: '.page-details__description',
    },
  });
}
